module.exports = __webpack_public_path__ + "entry-150bfe9b/Background_01_7x2_a-28d57fc08262a3c5357d4f5cd5021c8c.svg";